import { lazy } from 'react'

import { LAZY_LOAD_FAILURE_EVENT } from '@termly-web/common'

import trackEvent from 'utils/trackEvent'

// Everybody to the limit.
// https://www.youtube.com/watch?v=KFNcStdF_Ok
const KEY = 'fhqwhgads'

const LazyLoadFailed = require('./LazyLoadFailed')


// H/T: https://raphael-leger.medium.com/react-webpack-chunkloaderror-loading-chunk-x-failed-ac385bd110e0
export default function lazyLoad(importComponent) {
  return lazy(async () => {
    const isReloadPermitted = getReloadPermitted()

    try {
      return await importComponent()
    } catch {
      if ( !isReloadPermitted ) {
        trackEvent(LAZY_LOAD_FAILURE_EVENT)

        return LazyLoadFailed
      }

      try {
        setFlag({ isReloaded: true })

        window.location.reload()
      } catch (anotherError) {
        console.error("Could not set 'isReloaded' flag in localStorage: %o", anotherError)
      }

      // React.lazy requires this async function to resolve with a module
      // object ({ default: Component }). Returning undefined or throwing
      // both cause problems: undefined triggers a TypeError inside React's
      // lazy internals, and throwing generates Sentry noise for an error
      // we're already recovering from. Returning LazyLoadFailed gives React
      // something valid to render for the brief moment before the reload
      // navigates away.
      return LazyLoadFailed
    }
  })
}


function setFlag({ isReloaded }) {
  sessionStorage.setItem(KEY, isReloaded)
}

function getReloadPermitted() {
  try {
    return sessionStorage.getItem(KEY) !== 'true'
  } catch (error) {
    console.debug(error)
    return false
  }
}
